// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"cta_ctaWrapper__9DSRn","textWrapper":"cta_textWrapper__m7FDc"};